import * as React from 'react';

import { useAppSelector } from '@/redux/hooks';
import { getIsBot } from '@/redux/modules/analytics';
import { getSailthruCustomerId } from '@/redux/modules/config';

const SailthruInit = () => {
    const customerId = useAppSelector(getSailthruCustomerId);
    const isBot = useAppSelector(getIsBot);
    React.useEffect(() => {
        // @ts-ignore
        if (!isBot && window.Sailthru && window.Sailthru.init && !window.Sailthru.initRan) {
            try {
                // @ts-ignore
                window.Sailthru.init({
                    autoTrackPageview: false,
                    customerId,
                    isCustom: true,
                    useStoredTags: true,
                });
                // @ts-ignore
                window.Sailthru.initRan = true;
            } catch {
                // Sailthru can throw on malformed URLs (e.g., invalid percent encoding)
                // Fail silently to prevent crashing the app
            }
        }
    }, []); // eslint-disable-line
    return null;
};

export default SailthruInit;
